var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 42,
    viewBox: "0 0 144 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.057.002h6.96v7.036H.058z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.975 10.572c0-2.11-.637-3.166-1.912-3.166H6.817v25.188h1.246c1.275 0 1.912-1.055 1.912-3.166V10.572zm2.93-9.16c1.345.943 2.363 2.25 3.056 3.923.692 1.673 1.039 3.63 1.039 5.87v17.59c0 2.208-.347 4.157-1.04 5.846-.692 1.689-1.718 3.004-3.075 3.946C11.527 39.53 9.906 40 8.022 40H0V0h8.022c1.912 0 3.54.471 4.884 1.413zM111.536 0l.718 22.07h-.359L107.705 0H102v40h6.424l-.678-21.632h.359L112.135 40H118V0zM121 0v40h12v-7.016h-5.298v-9.939h4.656V16.03h-4.656V7.016h5.057V0zM93.383.077H27.378c-4.039 0-7.313 3.31-7.313 7.392v25.229c0 4.082 3.274 7.392 7.313 7.392h66.005c4.04 0 7.313-3.31 7.313-7.392V7.469c0-4.082-3.274-7.392-7.313-7.392zm0 6.6c.432 0 .784.356.784.792v25.229a.789.789 0 0 1-.784.792H27.378a.789.789 0 0 1-.784-.792V7.469c0-.436.352-.792.784-.792h66.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.901 39.128a.81.81 0 0 1-.805-.814v-3.372a.81.81 0 0 1 .805-.814h3.336a.81.81 0 0 1 .805.814v3.372a.81.81 0 0 1-.805.814H136.9z",
    fill: "#FF5726"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135.031 33.108)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.205.002H1.87C.869.002.057.822.057 1.834v3.372c0 1.011.812 1.832 1.813 1.832h3.335c1.001 0 1.813-.82 1.813-1.832V1.834A1.822 1.822 0 0 0 5.205.002zm-3.134 5h2.933V2.038H2.07v2.964z",
    fill: "#FF5726",
    mask: "url(#b)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneLogo);
export default __webpack_public_path__ + "static/media/done_logo.8abee5f99714da20ec0cff7f376ec1db.svg";
export { ForwardRef as ReactComponent };